/**
 * Service Dependencies
 */
import qs from 'qs'
import http from './HttpService'

/**
 * Retrieve company users
 *
 * @param  {Number} company
 * @return {Promise}
 */
export const getUsers = (company, params = {}) => {
    return http.get(`auth/companies/${company}/users/?${qs.stringify(params)}`)
}

/**
 * Update a user's privilege for a company
 *
 * @type {Promise}
 */
export const updateUserAdminStatus = (company, user, privilege) => {
    return http.patch(`auth/companies/${company}/users/${user}/`, privilege)
}

/**
 * Delete a user from a company
 *
 * @param  {Number} company
 * @param  {Number} user
 * @return {Promise}
 */
export const removeUser = (company, user) => {
    return http.del(`auth/companies/${company}/users/${user}/`)
}



// WEBPACK FOOTER //
// ./src/services/CompanyService.js